import MiniAppHeader from "./layout/MiniAppHeader";
import MiniAppContainer from "./MiniAppContainer";
import { useDispatch } from "react-redux";
import useFetchDashboardBotPerformance from "../../hooks/api/useFetchDashboardBotPerformance";
import MiniBotsList from "./mini-bots/MiniBotsList";
import Popup from "../../ui/Popup";
import { AiOutlinePlusCircle } from "react-icons/ai";
import noBot from "../../asset/Images/no-bot.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styles from "../../styles/pages/mini-app/MiniBots.module.css";
import MiniCreateBot from "./shared/MiniCreateBot";
import { useNavigate } from "react-router-dom";

function MiniBots() {
  const navigate = useNavigate();

  useFetchDashboardBotPerformance();

  return (
    <MiniAppContainer>
      <MiniAppHeader page="Bots Management">
        <Popup
          title={<AiOutlinePlusCircle size={20} />}
          height="300px"
          closePopup={true}
          popupClassName={styles.popup}
        >
          <LazyLoadImage
            src={noBot}
            alt="ai assistant"
            effect="blur"
            width="150px"
            height="150px"
          />

          <MiniCreateBot
            title="Create New Bot"
            btnClassName={`${styles.btn} ${styles.addBtn}`}
          />
          <span
            className={`${styles.btn} ${styles.linkBtn}`}
            onClick={() => navigate("/mini-community-bots")}
          >
            Go to Community
          </span>
        </Popup>
      </MiniAppHeader>
      <MiniBotsList />
      {/*<ServiceStatusBar*/}
      {/*  status={profileData?.mybot_active}*/}
      {/*  expirationDate={profileData?.mybot_active_until}*/}
      {/*  service={"mybot"}*/}
      {/*/>*/}

      {/*{getBotListLoading && <Loader />}*/}
      {/*{!getBotListLoading && botList?.length > 0 && <MiniBotSummary />}*/}
      {/*{!getBotListLoading && botList?.length === 0 && <NoBotBox />}*/}
    </MiniAppContainer>
  );
}

export default MiniBots;
